<div class="tab-container">
    <div *ngFor="let tab of tabs; let i = index" class="tab" [ngClass]="i === currentIndex ? 'tab-active' : ''" (click)="changeTab(tab)">
        {{ tab.name }}
    </div>
</div>
